import * as yup from 'yup'

export const loginSchema = yup.object().shape({
  email: yup.string().email('Invalid email').required('Email is required'),
  password: yup.string().required('Password is required'),
})

export const forgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .required('Email or phone number is required')
    .test('email-or-phone', 'Please enter a valid email or phone number', function (value) {
      if (!value) return false

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (emailRegex.test(value)) return true

      const cleanPhone = value.replace(/[\s\-()]/g, '')
      const phoneRegex = /^[+]?[1-9][\d]{10,13}$/

      if (phoneRegex.test(cleanPhone)) {
        const digitsOnly = cleanPhone.replace(/^\+/, '')
        if (digitsOnly.length >= 11 && digitsOnly.length <= 14) {
          return true
        }
      }

      return false
    }),
})

export const resetPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords must match')
    .required('Password confirmation is required'),
})